import { Injectable } from '@angular/core';
import { RequestResponse } from '../models/request-response.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';
import { OperationShiftManagerConstants } from '../constants/user-constants/operation-shift-manager.constants';
import { BaseTableColumns, InProgressRequestTableColumns } from '../models/table-columns/admin-table-columns.model';
@Injectable({
    providedIn: 'root'
})
export class OperationShiftManagerService {
    isExpiredSession: boolean = false;

    constructor(public dialog: MatDialog) {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        return new BaseTableColumns(
            response.id,
            response.requesterData.name,
            response.service.name,
            response.requesterData.client ? response.requesterData.client.name : 'N/A',
            response.createdAt
        );
    }

    getTableColumns(requestObjectName: string) {
        return OperationShiftManagerConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = OperationShiftManagerConstants[requestObjectName].tableColumn.map(c => c.columnDef);

        const tableWithSelection = OperationShiftManagerConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return OperationShiftManagerConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu() {
        const list = [
            OperationShiftManagerConstants.NEW_REQUESTS,
            OperationShiftManagerConstants.ASSIGNED_TO_ME_REQUESTS,
            OperationShiftManagerConstants.INPROGRESS_REQUESTS,
            OperationShiftManagerConstants.COMPLETED_REQUESTS,
            OperationShiftManagerConstants.COMPLETED_HISTORY_REQUESTS
        ];
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
}
